
import Vue from 'vue';
import { IconButtonTypes, Wrapper } from './styles';

export default Vue.extend({
  name: 'IconButton',
  components: {
    Wrapper,
  },
  props: {
    icon: {
      type: String,
      default: 'arrow-left',
      validator(value: typeof IconButtonTypes[number]) {
        return IconButtonTypes.indexOf(value) !== -1;
      },
    },
    handleFunction: {
      type: Function,
    },
  },
  methods: {
    execute() {
      if (this.handleFunction) this.handleFunction();
    },
  },
});
